import { NotificationMessageType, NotificationParams } from '@/modules/notifications/types'
import { addNotification } from './addNotification'

export const addSuccessNotification = (
  message: NotificationParams['message'],
  notification?: Omit<NotificationParams, 'messageType' | 'message'>,
) => addNotification({ ...notification, messageType: NotificationMessageType.Success, message })
